import { useState } from 'react'

export function useDateRangeStack() {
	const [yesterdayStack, setYesterdayStack] = useState(0)
	const [lastMonthStack, setLastMonthStack] = useState(0)

	const resetStacks = () => {
		setYesterdayStack(0)
		setLastMonthStack(0)
	}

	const resetOppositeStack = (type: 'yesterday' | 'lastMonth') => {
		if (type === 'yesterday') {
			setLastMonthStack(0)
		} else if (type === 'lastMonth') {
			setYesterdayStack(0)
		}
	}

	const incrementStack = (type: 'yesterday' | 'lastMonth') => {
		if (type === 'yesterday') {
			setYesterdayStack((prev) => prev + 1)
		} else if (type === 'lastMonth') {
			setLastMonthStack((prev) => prev + 1)
		}
	}

	return {
		yesterdayStack,
		lastMonthStack,
		resetStacks,
		resetOppositeStack,
		incrementStack,
	}
}
